import React, { useMemo, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import QuillTableBetter from 'quill-table-better';
import 'quill-table-better/dist/quill-table-better.css';

Quill.register('modules/table-better', QuillTableBetter, true);

const TABLE_STYLES = `
  .ql-editor table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 10px 0;
  }

  .ql-editor table td,
  .ql-editor table th {
    border: 1px solid #000;
    padding: 5px 10px;
    min-width: 50px;
    min-height: 20px;
    position: relative;
  }

  .ql-editor table th {
    background-color: #f1f3f4;
    font-weight: bold;
  }

  .ql-editor .ql-table-better {
    border: 1px solid #ccc;
  }

  .ql-editor .ql-table-better td {
    border: 1px solid #ccc;
    padding: 5px;
    min-width: 50px;
    min-height: 20px;
    position: relative;
  }

  .ql-editor .ql-table-better .ql-table-better-cell-selected {
    background-color: #b3d9ff;
  }

  .ql-table-better__wrapper {
    position: relative;
  }

  .ql-table-better__menu {
    position: absolute;
    z-index: 1000;
    border: 1px solid #ccc;
    background: white;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }

  .ql-table-better__menu-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }

  .ql-table-better__menu-item:hover {
    background-color: #f5f5f5;
  }

  .ql-table-better__menu-item:last-child {
    border-bottom: none;
  }
`;

export const quillModules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      ['link', 'image'],
      ['blockquote', 'code-block'],
      ['table-better'],
      ['clean'],
    ],
  },
  table: false,
  'table-better': {
    language: 'en_US',
    menus: ['column', 'row', 'merge', 'table', 'cell', 'wrap', 'copy', 'delete'],
    toolbarTable: true,
    operationMenu: {
      items: {
        unmergeCells: {
          text: 'Another unmerge cells name',
        },
      },
      color: {
        colors: ['green', 'red', 'yellow', 'blue', 'white'],
        text: 'Background Colors:',
      },
    },
  },
  keyboard: {
    bindings: QuillTableBetter.keyboardBindings,
  },
  clipboard: {
    matchVisual: false,
  },
};

export const quillFormats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'indent',
  'link',
  'image',
  'color',
  'background',
  'align',
  'script',
  'code-block',
  'table-cell',
  'table-cell-block',
  'table-header',
  'table-list',
];

export function isRichTextEmpty(content: string): boolean {
  const contentText = content.replace(/<[^>]*>/g, '').trim();
  return !contentText || content === '<p><br></p>';
}

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  height?: number;
  className?: string;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Nhập nội dung...',
  height = 300,
  className = '',
}) => {
  const quillRef = useRef<ReactQuill>(null);
  const modules = useMemo(() => quillModules, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: TABLE_STYLES }} />
      <div className={`border border-gray-200 rounded-lg overflow-hidden ${className}`}>
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          formats={quillFormats}
          placeholder={placeholder}
          style={{
            height,
            marginBottom: '50px',
          }}
          preserveWhitespace
        />
      </div>
    </>
  );
};
